import axios from "axios";
import { getPublicQuoteBaseUrl } from "../config/domains";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = BACKEND_URL.endsWith("/api")
  ? BACKEND_URL
  : `${BACKEND_URL || ""}/api`;

export const api = axios.create({ baseURL: API });

export const formatINR = (n) => {
  if (n === null || n === undefined) return "—";
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `₹${n}`;
  }
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const shortId = (id) => (id ? id.slice(0, 8).toUpperCase() : "—");

export const buildShareUrl = (token) => {
  const base = getPublicQuoteBaseUrl() || window.location.origin;
  return `${base}/q/${token}`;
};
